export default [
    {
        path: '/scheduler/diary',
        name: 'DiaryScheduler',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Diary',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/scheduler/diary/SchedulerIndex.vue'),
            agent: () => import('@views/scheduler/diary/SchedulerIndex.vue'),
        },
    },
    {
        path: '/scheduler/fix-list',
        name: 'DiaryFixList',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Fix list',
            fullWidth: true,
        },
        component: () => import('@views/scheduler/diary/FixListIndex.vue'),
    },
];
